import { render } from "./select-option.html?vue&type=template&id=b627b244&scoped=true&ts=true"
import script from "./select-option.vue?vue&type=script&lang=ts"
export * from "./select-option.vue?vue&type=script&lang=ts"

import "./select-option.scss?vue&type=style&index=0&id=b627b244&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b627b244"]])

export default __exports__